import * as React from 'react';

const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M7.9 2.81953C8.39706 2.81953 8.8 3.22248 8.8 3.71953V4.31953H15V3.71953C15 3.22248 15.4029 2.81953 15.9 2.81953C16.3971 2.81953 16.8 3.22248 16.8 3.71953V4.31953H18.9C19.4039 4.31953 19.8872 4.51971 20.2435 4.87603C20.5998 5.23235 20.8 5.71562 20.8 6.21953V19.2195C20.8 19.7234 20.5998 20.2067 20.2435 20.563C19.8872 20.9194 19.4039 21.1195 18.9 21.1195H4.9C4.39609 21.1195 3.91282 20.9194 3.5565 20.563C3.20018 20.2067 3 19.7234 3 19.2195V6.21953C3 5.71562 3.20018 5.23235 3.5565 4.87603C3.91282 4.51971 4.39609 4.31953 4.9 4.31953H7V3.71953C7 3.22248 7.40294 2.81953 7.9 2.81953ZM7 6.11953H4.9C4.87348 6.11953 4.84804 6.13007 4.82929 6.14882C4.81054 6.16758 4.8 6.19301 4.8 6.21953V9.31953H19V6.21953C19 6.19301 18.9895 6.16758 18.9707 6.14882C18.952 6.13007 18.9265 6.11953 18.9 6.11953H16.8V6.71953C16.8 7.21659 16.3971 7.61953 15.9 7.61953C15.4029 7.61953 15 7.21659 15 6.71953V6.11953H8.8V6.71953C8.8 7.21659 8.39706 7.61953 7.9 7.61953C7.40294 7.61953 7 7.21659 7 6.71953V6.11953ZM19 11.1195H4.8V19.2195C4.8 19.2461 4.81054 19.2715 4.82929 19.2902C4.84804 19.309 4.87348 19.3195 4.9 19.3195H18.9C18.9265 19.3195 18.952 19.309 18.9707 19.2902C18.9895 19.2715 19 19.2461 19 19.2195V11.1195Z"
      fill="#71717A"
    />
  </svg>
);
export default SVGComponent;
